import { AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Cart } from '../../model/cart';
import { Subscription } from 'rxjs';
import { CustomerService } from '../../services/customer.service';
import { SessionStorageService } from '../../services/session-storage.service';
import { CartService } from '../../services/cart.service';
import { SnackBarService } from '../../services/snack-bar.service';
import { ActivatedRoute } from '@angular/router';
import { DiscountModalService } from '../../services/discount-modal.service';
import { LoadingService } from '../../services/loading.service';
import { Customer } from '../../model/customer';

class ProductUpdate {

  productValue: string;
  discountedValue: string;
  totalValue: string;

  constructor(_productValue: Number, _discountedValue: Number, _totalValue: Number) {
    this.productValue = Number(_productValue).toFixed(2).replace('.', ',');
    this.discountedValue = Number(_discountedValue).toFixed(2).replace('.', ',');;
    this.totalValue = Number(_totalValue).toFixed(2).replace('.', ',');;
  }
}

@Component({
    selector: 'pme-disconnected-sale-discount-form',
    templateUrl: './disconnected-sale-discount-form.component.html',
    styleUrls: ['./disconnected-sale-discount-form.component.scss'],
    standalone: false
})
export class DisconnectedSaleDiscountFormComponent implements OnInit, AfterViewInit {

  @Output() productUpdateEmit = new EventEmitter<ProductUpdate>();
  @Output() cartUpdated: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() cart: Cart;

  automaticRechargeFormControl = new UntypedFormControl();
  productIdentifier: string;

  isBankBillet: boolean;
  isPix: boolean;

  currentPaymentMethod: string;
  lastPaymentOption: string;
  isFocused: boolean = false;
  theresValue: boolean = false;
  submittingCouponCode = false;
  couponAppliedManually = false;
  isAplicarButton;
  couponIsInvalid = false;
  couponIdentifier = "";
  apliedCoupons: Array<any> = []
  couponError = "";

  cartErrors: Array<string> = [];
  additionalData: any;

  couponFb: UntypedFormGroup;
  allowAutomaticRecharge: boolean;
  lastAutomaticRechargeValue: boolean = true;
  invalidCoupon: boolean;

  showAutomaticRechargeOnlyMessage: boolean;

  classificationIdentifier: string;
  returnToShopWindowText: string = "Alterar plano";

  showFormularyCoupon: boolean = true;


  // Cupons	
  extraBalanceCoupon: any;
  extraBalanceSum: number = 0;
  appliedCoupons: any = [];
  trialCoupon: any = null;
  filteredCoupons: any;

  // Subscribers	
  automaticRechargeSubscriber: Subscription;

  constructor(
    public formBuilder: UntypedFormBuilder,
    private customerService: CustomerService,
    private sessionStorageService: SessionStorageService,
    public cartService: CartService,
    private snackBarService: SnackBarService,
    private changeDetectorRef: ChangeDetectorRef,
    private route: ActivatedRoute,
    private discountModalService: DiscountModalService,
    private loading: LoadingService,
  ) {
    //this.cart = this.cartService.getCurrentCart();

    this.couponFb = this.formBuilder.group({
      couponIdentifier: [""]
    });
  }

  ngOnChanges() {
    if (this.cart) {
      this.processCoupon();
    }
  }

  ngOnInit(): void {
    this.apliedCoupons = this.cart.appliedDiscounts;
  }

  ngAfterViewInit() {
    this.checkForExtraBalanceCoupon();

    this.discountModalService.discountIdentifierModal.subscribe((discountIdentifier) => {
      if (discountIdentifier) {
        this.cart.couponIdentifier = discountIdentifier;
        //this.applyCoupon(false);
      }
    });
    // this.checkShowFormularyCoupon();

    this.loading.finishTask();
  }

  checkForExtraBalanceCoupon() {
    this.appliedCoupons = [];
    this.extraBalanceCoupon = [];
    this.extraBalanceSum = 0;

    if (this.cart && this.cart.appliedDiscounts) {
      this.cart.appliedDiscounts.forEach(discount => {
        if (discount.type === "EXTRA_BALANCE") {
          this.extraBalanceCoupon.push(discount);
        } else {
          this.appliedCoupons.push(discount);
        }
      });

    }

    if (this.extraBalanceCoupon.length > 0) {
      this.extraBalanceSum = this.extraBalanceCoupon.reduce((accumulator, discount) => {
        return accumulator + discount.extraBalance;
      }, 0);
    }
  }

  formatCoupon() {
    this.cart.couponIdentifier = this.cart.couponIdentifier
      .toUpperCase()
      .replace(/[^A-Z0-9_]/g, "");

    this.couponIdentifier = this.cart.couponIdentifier;
  }

  applyCoupon() {
    this.isAplicarButton = true;
    sessionStorage.setItem('isAplicarButton', this.isAplicarButton.toString());
    this.couponAppliedManually = true;
    this.couponIdentifier = this.couponFb.value.couponIdentifier;
    this.cart.couponIdentifier = this.couponFb.value.couponIdentifier;
    this.setCouponValidationData();
    this.updateCoupon("PAYMENT");
  }

  removeCoupon() {
    this.cart.couponIdentifier = "";
    this.isAplicarButton = false;
    sessionStorage.setItem('isAplicarButton', this.isAplicarButton.toString());
    sessionStorage.removeItem("coupon");
    this.couponAppliedManually = false;
    this.updateCoupon("PAYMENT");
  }

  updateCoupon(saleStep: string) {
    // TODO - pensar numa solucao melhor pra esse booleano do parametro
    this.cartErrors = [];
    this.submittingCouponCode = true;

    const couponIdentifier = this.cart.couponIdentifier;
    const productIdentifier = this.sessionStorageService.getCustomData('productIdentifier');
    this.cartService.setCart(this.cart);

    this.additionalData = this.sessionStorageService.getValidationData();

    this.cartService
      .simulate(this.cart._id, this.cart.type, productIdentifier, saleStep, [couponIdentifier],
        null, null, null, this.additionalData).subscribe(
          (simulatedCarts) => {
            this.cartService.setCarts(simulatedCarts);
            // this.cartService.setCart(simulatedCarts[0])


            const currentPaymentMethod = this.cart.paymentMethod.identifier;
            this.cartService.setCartByPaymentMethod(currentPaymentMethod);
            this.cartUpdated.emit(true);
            this.cart = this.cartService.getCurrentCart();
            // Valida se algum cupom foi aplicado com sucesso no carrinho

            this.processCoupon();

          },
          (error) => {
          }
        );
    this.checkForExtraBalanceCoupon();
    this.checkForTrialCoupon();
  }

  hasValidAppliedCoupon(): boolean {
    return this.cart.appliedDiscounts.find(discount => {
      return discount.identifier === this.couponIdentifier
    }) ? true : false;
  }

  processCoupon() {
    if (!this.couponIdentifier || this.couponIdentifier === "") {
      return;
    }
    this.cart.hasValidAppliedCoupon = this.hasValidAppliedCoupon();


    if (this.cart.hasValidAppliedCoupon) {
      this.couponIsInvalid = false;
      this.snackBarService.openSnackBar("Cupom aplicado");
      this.sessionStorageService.setCoupon(this.cart.couponIdentifier);
      this.couponFb.controls.couponIdentifier.disable();
      this.cartService.couponUpdated.next(true);
      this.cartService.setCart(this.cart);
    } else if (
      !this.cart.hasValidAppliedCoupon &&
      this.couponAppliedManually
    ) {
      this.couponIsInvalid = true;
      this.sessionStorageService.setCoupon(this.couponIdentifier);
      this.cartService.couponUpdated.next(true);
      this.couponFb.controls.couponIdentifier.disable();
    } else {
      this.couponIsInvalid = false;
      this.couponIdentifier = "";
      this.couponFb.value.couponIdentifier = "";
      this.sessionStorageService.setCoupon("");
      this.snackBarService.openSnackBar("Cupom removido");
      this.cartService.couponUpdated.next(true);
      this.couponFb.controls.couponIdentifier.enable();
    }
    this.productUpdateEmit.emit(new ProductUpdate(this.cart.baseValue, this.cart.discountedValue, this.cart.totalValue));

    this.submittingCouponCode = false;
    this.update();
  }

  setCouponValidationData() {
    let customer = this.customerService.getCurrentCustomer();
    if (!customer) {
      customer = new Customer();
    }
    const provisioningParameters = customer.provisioningParameter;
    if (customer && this.cart) {
      this.cart.validationData = {
        cnpj: customer.cnpj,
        cpf: customer.cpf,
        email: customer.email,
        businessId: provisioningParameters.businessId || null,
        userId: provisioningParameters.userId || null,
        allowAutomaticRecharge: customer.provisioningParameter.allowAutomaticRecharge ?
          provisioningParameters.allowAutomaticRecharge === true : null,
      };
      this.sessionStorageService.setValidationData(this.cart.validationData);
      this.cartService.setCart(this.cart);
    }
  }

  update() {

    this.cart = this.cartService.getCurrentCart();
    if (this.cart) {
      // const ccCart = this.cartService.getCartByPaymentMethod("CREDIT_CARD");

      // if (ccCart) {
      //   this.installments = this.cart.getInstallmentsByIdentifier(
      //     this.lastPaymentOption
      //   );
      // }


      // this.installments = this.cart.getInstallmentsByIdentifier('CREDIT_CARD');
      this.sessionStorageService.setClassification(
        this.cart.product.classificationIdentifier
      );
      this.sessionStorageService.setClassificationName(
        this.cart.product.classificationName
      );

      this.currentPaymentMethod = this.cart.paymentMethod.identifier;
      this.isBankBillet = this.cart.paymentMethod.identifier === "BANK_BILLET";
      this.isPix = this.cart.paymentMethod.identifier === "PIX";

      if (!this.hasValidAppliedCoupon()) {
        this.cart.couponIdentifier = this.couponIdentifier;
      }

      if (this.cart.couponIdentifier && this.hasValidAppliedCoupon()) {
        this.couponFb.controls.couponIdentifier.disable();
      } else {
        if (!this.cart.couponIdentifier) {
          this.couponFb.controls.couponIdentifier.enable();
        }
      }

      this.cart.validationData = this.sessionStorageService.getValidationData();

      this.changeDetectorRef.detectChanges();

      this.classificationIdentifier = this.sessionStorageService.getClassification(this.route);

      if (sessionStorage.getItem("isAplicarButton") && sessionStorage.getItem("isAplicarButton") === "true" && this.cart.couponIdentifier) {
        this.isAplicarButton = true;
      } else if (this.cart.couponIdentifier === "") {
        this.isAplicarButton = false;
      }
    }
    this.checkForExtraBalanceCoupon();
    this.checkForTrialCoupon();
  }

  checkForTrialCoupon() {
    this.appliedCoupons = [];
    this.filteredCoupons = [];
    this.trialCoupon = null;
    if (this.cart && this.cart.appliedDiscounts) {
      this.cart.appliedDiscounts.forEach(discount => {
        if (discount.type === "TRIAL") {
          this.trialCoupon = discount;
        } else {
          this.appliedCoupons.push(discount);
        }
      });
      this.filteredCoupons = this.appliedCoupons.filter(el => el.type !== 'EXTRA_BALANCE');
    }
  }

}
